import React, { useState } from 'react';
import Link from 'next/link';
import { Nav, Collapse } from 'react-bootstrap';
import { useRouter } from 'next/router';

interface NavigationItemProps {
  title: string;
  path?: string;
  isActive: boolean;
  children?: React.ReactNode;
  megaMenu?: boolean;
  hasSubMenu?: boolean;
  depth?: number;
  onClick?: () => void;
  icon?: string;
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  title,
  path,
  isActive,
  children,
  megaMenu = false,
  hasSubMenu = false,
  depth = 0,
  onClick,
  icon
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const handleClick = () => {
    if (hasSubMenu) {
      setIsOpen(!isOpen);
    }
    if (onClick) {
      onClick();
    }
  };

  // If it's a simple link with no children
  if (!hasSubMenu && path) {
    return (
      <Nav.Item as="li">
        <Link
          href={path}
          className={`nav-link ${isActive ? 'active' : ''} ${megaMenu && depth === 0 ? 'p-0' : ''}`}
        >
          {icon && <i className={`${icon} me-2`}></i>}
          <span className="d-inline-block">{title}</span>
        </Link>
      </Nav.Item>
    );
  }

  // If it has a submenu
  return (
    <Nav.Item as="li">
      <Nav.Link
        aria-expanded={isOpen}
        onClick={handleClick}
        className={isActive ? 'active' : ''}
      >
        <span className="item-name">{title}</span>
        {hasSubMenu && (
          <span className="menu-icon ms-2">
            <i
              className={
                depth === 0
                  ? "fa fa-caret-down toggledrop-desktop right-icon"
                  : "fa fa-caret-right toggledrop-desktop right-icon"
              }
              aria-hidden="true"
            ></i>
            <span className="toggle-menu">
              <i className="fa fa-plus arrow-active text-white" aria-hidden="true"></i>
              <i className="fa fa-minus arrow-hover text-white" aria-hidden="true"></i>
            </span>
          </span>
        )}
      </Nav.Link>
      {hasSubMenu && (
        <Collapse
          in={isOpen}
          className={`sub-nav ${megaMenu && depth === 0 ? 'mega-menu-item' : ''} ${depth === 0 ? 'list-unstyled' : ''}`}
        >
          <ul className={depth > 0 ? 'list-unstyled' : undefined}>
            {children}
          </ul>
        </Collapse>
      )}
    </Nav.Item>
  );
};

export default NavigationItem;
